import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/cn"

const pageContainerVariants = cva(
    "w-full mx-auto px-4 sm:px-6 lg:px-8",
    {
        variants: {
            size: {
                default: "max-w-[1440px]",
                content: "max-w-7xl",
                narrow: "max-w-4xl",
            },
        },
        defaultVariants: {
            size: "default",
        },
    }
)

export interface PageContainerProps
    extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof pageContainerVariants> {
    as?: React.ElementType
}

const PageContainer = React.forwardRef<HTMLDivElement, PageContainerProps>(
    ({ className, size, as: Component = "div", ...props }, ref) => {
        return (
            <Component
                ref={ref}
                className={cn(pageContainerVariants({ size, className }))}
                {...props}
            />
        )
    }
)
PageContainer.displayName = "PageContainer"

export { PageContainer, pageContainerVariants }
